/**
 * Standard commercial GCP regions for engagement onboarding.
 * Used by "Select All Regions" and the region dropdown.
 */
export const GCP_REGION_OPTIONS: { value: string; label: string }[] = [
  { value: 'africa-south1', label: 'Africa (Johannesburg)' },
  { value: 'asia-east1', label: 'Asia (Taiwan)' },
  { value: 'asia-east2', label: 'Asia (Hong Kong)' },
  { value: 'asia-northeast1', label: 'Asia (Tokyo)' },
  { value: 'asia-northeast2', label: 'Asia (Osaka)' },
  { value: 'asia-northeast3', label: 'Asia (Seoul)' },
  { value: 'asia-south1', label: 'Asia (Mumbai)' },
  { value: 'asia-south2', label: 'Asia (Delhi)' },
  { value: 'asia-southeast1', label: 'Asia (Singapore)' },
  { value: 'asia-southeast2', label: 'Asia (Jakarta)' },
  { value: 'australia-southeast1', label: 'Australia (Sydney)' },
  { value: 'australia-southeast2', label: 'Australia (Melbourne)' },
  { value: 'europe-central2', label: 'Europe (Warsaw)' },
  { value: 'europe-north1', label: 'Europe (Finland)' },
  { value: 'europe-southwest1', label: 'Europe (Madrid)' },
  { value: 'europe-west1', label: 'Europe (Belgium)' },
  { value: 'europe-west2', label: 'Europe (London)' },
  { value: 'europe-west3', label: 'Europe (Frankfurt)' },
  { value: 'europe-west4', label: 'Europe (Netherlands)' },
  { value: 'europe-west6', label: 'Europe (Zürich)' },
  { value: 'europe-west8', label: 'Europe (Milan)' },
  { value: 'europe-west9', label: 'Europe (Paris)' },
  { value: 'europe-west10', label: 'Europe (Berlin)' },
  { value: 'europe-west12', label: 'Europe (Turin)' },
  { value: 'me-central1', label: 'Middle East (Doha)' },
  { value: 'me-central2', label: 'Middle East (Dammam)' },
  { value: 'me-west1', label: 'Middle East (Tel Aviv)' },
  { value: 'northamerica-northeast1', label: 'North America (Montréal)' },
  { value: 'northamerica-northeast2', label: 'North America (Toronto)' },
  { value: 'southamerica-east1', label: 'South America (São Paulo)' },
  { value: 'southamerica-west1', label: 'South America (Santiago)' },
  { value: 'us-central1', label: 'US (Iowa)' },
  { value: 'us-east1', label: 'US (South Carolina)' },
  { value: 'us-east4', label: 'US (Northern Virginia)' },
  { value: 'us-east5', label: 'US (Columbus)' },
  { value: 'us-south1', label: 'US (Dallas)' },
  { value: 'us-west1', label: 'US (Oregon)' },
  { value: 'us-west2', label: 'US (Los Angeles)' },
  { value: 'us-west3', label: 'US (Salt Lake City)' },
  { value: 'us-west4', label: 'US (Las Vegas)' }
];

export const GCP_ALL_REGION_CODES: string[] = GCP_REGION_OPTIONS.map((o) => o.value);

/** Dropdown value meaning "persist all regions from GCP_ALL_REGION_CODES" */
export const GCP_SELECT_ALL_REGIONS_VALUE = '__ALL_GCP_REGIONS__';

export type GcpRegionOption = (typeof GCP_REGION_OPTIONS)[number];
